// extracted by mini-css-extract-plugin
module.exports = {"customProgressBar":"SignalStrength_customProgressBar__2rIEZ","customHighlightBar":"SignalStrength_customHighlightBar__zjxtB"};